// imports
import LazyLoad from "vanilla-lazyload";
var Flickity = require("flickity");
const $ = require("jquery");
import "./components/navigation.js";
import "./components/search-modal.js";
import activeMenu from './utils/menu-active';
var Accordion = require("./components/accordion.js");
var styleDir = object_name.stylesheetDirectory;
var body = document.querySelector("body");
var html = document.querySelector("html");

setTimeout(function () {
  body.classList.add("ready");
}, 50);
  setTimeout(function () {
    document.querySelector("#loading").remove();
  }, 250);

//lazy load options
const lazyLoadOptions = {};
const pageLazyLoad = new LazyLoad(lazyLoadOptions);
pageLazyLoad.update();

$(document).on("sf:ajaxfinish", ".searchandfilter", function(){
  pageLazyLoad.update();
});